var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"modal-body"},[_c('CroutonPlaceholder',{attrs:{"defaultStyle":"innerFormStyle"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }